import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { IAuthService } from 'src/app/core/services/api/contracts/auth-service';
import { DocumentProcessService } from 'src/app/core/services/api/document-process.service';
import { IotaService } from 'src/app/core/services/api/iota.service';
import { ApiDocumentProcessModel } from '../../../../core/models/api-document-process.model';
import { DateHelper } from 'src/app/core/helpers/date-helper';
import { AuthInterceptor } from 'src/app/core/handler/auth-interceptor';
import { IWService } from 'src/app/core/services/iw.service';
import { BasicModalOperationResult, DialogModalComponent, IBasicModalComponentInstance } from 'src/app/shared/components/dialog-modal/dialog-modal.component';
import { SystemAccountAuthModel } from 'src/app/core/models/system-account';
import { UserRoles } from 'src/app/core/models/enums/userRoles';
import { DocumentProcessToStatusGrid, DocumentProcessToStatusGridTranslate } from 'src/app/core/models/enums/documentProcessToStatusGridEnum';
import { DocumentProcessStatus } from 'src/app/core/models/enums/documentProcessStatusEnum';
import { ApiDocumentProcessToModel } from 'src/app/core/models/api-document-processs-to.model';
import { DocumentProcessToStatus } from 'src/app/core/models/enums/documentProcessToStatusEnum';
import { ConsoleLogger } from '@angular/compiler-cli';

@Component({
  selector: 'app-document-process-details',
  templateUrl: './document-process-details.component.html',
  styleUrls: ['./document-process-details.component.scss']
})
export class DocumentProcessDetailsComponent implements OnInit {
  documentProcess: ApiDocumentProcessModel = new ApiDocumentProcessModel();
  documentProcessStatus = DocumentProcessStatus;
  documentProcesstoStatusGrid = DocumentProcessToStatusGrid;
  showSpinner: boolean = true;
  submitting: boolean = false;
  documentProcessId: number;
  currentUser: SystemAccountAuthModel;
  documentProcessToStatusGridTranslate = DocumentProcessToStatusGridTranslate;
  disabedSignButton: boolean = true;
  documentSignatureInProgress: boolean = false;
  test: string = "admin";
  isvisible: boolean = false;
  documentsByOrganization: any;
  explorerUrl: string | null = null;

  constructor(
    private route: ActivatedRoute,
    public translate: TranslateService,
    private documentProcessService: DocumentProcessService,
    private iotaService: IotaService,
    private modalService: NgbModal,
    private router: Router,
    public iwService: IWService,
    @Inject("IAuthService") private authService: IAuthService
  ) { }

  async ngOnInit() {
    this.showSpinner = true;
    this.currentUser = await this.authService.getCurrentProfile();
    this.documentProcessId = Number(this.route.snapshot.paramMap.get("document-process-id"));
    await this.loadData();
    this.showSpinner = false;
    await this.groupByOrganization();
    //this.setDisabedSignButton();
  }

  setDisabedSignButton(){
    this.documentSignatureInProgress = false; 
    this.disabedSignButton = true;
    let currentDocumentProcessTo: ApiDocumentProcessToModel;
    currentDocumentProcessTo = this.documentProcess.documentProcessTos.find(x => x.isOrganization && x.sintraId == this.currentUser.organization.code);
    if(currentDocumentProcessTo == undefined){
      currentDocumentProcessTo = this.documentProcess.documentProcessTos.find(x => !x.isOrganization && x.sintraId == this.currentUser.sintraId);
    }
    
    if(currentDocumentProcessTo != undefined &&
      (currentDocumentProcessTo.isSignatory  || this.currentUser.organization.isParentOrganization) &&
      currentDocumentProcessTo.status == DocumentProcessToStatus.Pending){
        this.disabedSignButton = false;
      }
    if(this.disabedSignButton && 
      ((currentDocumentProcessTo == undefined &&
         this.documentProcess.documentProcessStatus == DocumentProcessStatus.Pending ) //Incucai Emergencia sin haber sido asignado
         || 
        (currentDocumentProcessTo != undefined && 
          !currentDocumentProcessTo.isSignatory && 
          currentDocumentProcessTo.isOrganization && 
          currentDocumentProcessTo.sintraId == this.currentUser.organization.code  
          && currentDocumentProcessTo.status != DocumentProcessToStatus.Signed )) //Incucai Emergencia asignado solo lectura
          &&
      this.currentUser && 
      this.currentUser.currentRole == UserRoles.Operador &&
      this.currentUser.organization.isParentOrganization ){
        this.disabedSignButton = false;        
    }  
    if(this.documentProcess.documentSignatureInProgress){
      this.disabedSignButton = true;  
      this.documentSignatureInProgress = true; 
      console.log('documentSignatureInProgress!');
    }
  }

  signatureMessageTooltipTitle() {
    let message = "";
    if (this.documentSignatureInProgress) {
      message = this.translate.instant("documentSignatureInProcess");
    }
    else{
      message = this.translate.instant("documentsGrid.signDocument")
    }
    return message;
  }
  
  async loadData() {
    try{
      this.documentProcess = await this.documentProcessService.getDocumentProcessDetails(this.documentProcessId);

      this.documentProcess.documentProcessTos.forEach(item => {
        const date = new Date(item.updateDate); 
        const formattedDate = date.toLocaleDateString("es-ES"); 
        const formattedTime = date.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" }); 
      
        item.updateDate = `${formattedDate} ${formattedTime}`;
      });
    }
    catch{
      this.redirect();
      return;
    }
    this.explorerUrl = await this.iotaService.getNotarizationExplorerUrl(this.documentProcessId);
  }

  convertDate(dateToBeConverted: Date) {
    if (dateToBeConverted) {
      return DateHelper.convertDate(dateToBeConverted)
    }
  }

  async signDocument() {

    try {
      this.showSpinner = true;
      this.submitting = true;
      
      await this.documentProcessService.extrSignProcessDocument(
        this.documentProcess.documentId,
        this.translate.currentLang
      );

      this.showSpinner = false;
      this.submitting = false;

      await this.showSuccessfulDocumentSignatureMessage();

      this.redirect();

    } catch (error) {
      alert(this.translate.instant("signatureErrorMessage"));
      this.showSpinner = false;
      this.submitting = false;
    }
  }

  async showSuccessfulDocumentSignatureMessage() {
    const modalRef = this.modalService.open(DialogModalComponent, {
      backdrop: "static",
      keyboard: false,
    });

    const modalInstance =
      modalRef.componentInstance as IBasicModalComponentInstance;
    modalInstance.title = this.translate.instant(
      "documentsGrid.signedDocumentTitle"
    );
    modalInstance.body = this.translate.instant(
      "documentsGrid.signedDocumentBody"
    );
    modalInstance.type = BasicModalOperationResult.Success;

    await modalRef.result;
  }

  redirect(){
    if (this.currentUser && this.currentUser.currentRole == UserRoles.Admin) {
      this.router.navigate(["/admin/documents"]);
    }

    if (this.currentUser && this.currentUser.currentRole == UserRoles.Operador) {
      this.router.navigate(["/guest/documents"]);
    }
  }

  async groupByOrganization() {
    this.documentsByOrganization = this.documentProcess.documentProcessTos.reduce((acc, document) => {
      if (!acc[document.sintraId]) {
        acc[document.sintraId] = [];
      }
      acc[document.sintraId].push(document);
      return acc;
    }, {});
  
    for (const organization in this.documentsByOrganization) {
      if (Object.prototype.hasOwnProperty.call(this.documentsByOrganization, organization)) {
        const documents = this.documentsByOrganization[organization];
  
        this.documentsByOrganization[organization] = documents;
      }
    }
  }

}
